import { createSlice } from '@reduxjs/toolkit';
import { createSliceHook } from '@restore/helpers';
import {
  SetSelectedCohortTypeAction,
  ToggleExpandedRowsTypeAction,
} from '@restore/clinicalTrialForms/clinicalTrialForms.types';
import { CohortType } from '@dynamika-shared/types/cohorts';

type ClinicalTrialFormsState = {
  expandedRows: Record<string, string[]>;
  selectedCohort: Record<string, CohortType | null>;
};

const initialState: ClinicalTrialFormsState = {
  expandedRows: {},
  selectedCohort: {},
};

export const clinicalTrialForms = createSlice({
  name: 'clinicalTrialForms',
  initialState,
  reducers: {
    toggleExpandedRows: (state, action: ToggleExpandedRowsTypeAction) => {
      const current = state.expandedRows[action.payload.key] || [];

      if (action.payload.expanded) {
        state.expandedRows[action.payload.key] = [
          ...current,
          action.payload.row,
        ];
      } else {
        state.expandedRows[action.payload.key] = current.filter(
          id => id !== action.payload.row
        );
      }
    },
    clearExpandedRows: state => {
      state.expandedRows = {};
    },
    setSelectedCohort: (state, action: SetSelectedCohortTypeAction) => {
      state.selectedCohort[action.payload.key] = action.payload.cohort;
    },
  },
});

export const useClinicalTrialFormSlice = createSliceHook(
  clinicalTrialForms.name,
  clinicalTrialForms.actions
);
